import type { RouteNamedMap } from 'vue-router/auto-routes'
import { useProjectDataVisualizationsStore } from '~/stores/projectDataVisualizations/projectDataVisualizations'
import {
  useProjectDataVisualizationSelectionStore,
  type SelectionSnapshot,
} from '~/stores/projectDataVisualizations/projectDataVisualizationsSelection'

export const useChartRefresh = ({
  fetchChartFunction,
  routeName,
}: {
  fetchChartFunction: (args: SelectionSnapshot) => Promise<void>
  routeName: keyof RouteNamedMap
}) => {
  const ProjectDataVisualizationsStore = useProjectDataVisualizationsStore()
  const ProjectDataVisualizationsSelectionStore =
    useProjectDataVisualizationSelectionStore()

  const route = useRoute()

  watch(
    () => ProjectDataVisualizationsSelectionStore.snapshot(),
    async (newVersion, oldVersion) => {
      const matchingRoute = route.name && route.name === routeName

      if (newVersion.selectionVersion === oldVersion?.selectionVersion) {
        return
      }

      if (!matchingRoute) {
        return
      }

      const isValidForThisDataVizType =
        routeName === 'project-overview'
          ? ProjectDataVisualizationsSelectionStore.isValidOverview
          : ProjectDataVisualizationsSelectionStore.isValid

      if (isValidForThisDataVizType) {
        const analysisFilterChanged =
          newVersion.analysisID !== oldVersion?.analysisID ||
          newVersion.proportionalAnalysisTypeID !==
            oldVersion.proportionalAnalysisTypeID

        if (analysisFilterChanged || routeName === 'project-overview') {
          await ProjectDataVisualizationsStore.getFilters()
        }

        nextTick(async () => {
          ProjectDataVisualizationsStore.dataLoadError.message = ''

          await fetchChartFunction(
            ProjectDataVisualizationsSelectionStore.snapshot()
          )
        })
      }
    },
    { immediate: true }
  )
}
